var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`icon icon-${_vm.icon}`,style:(`color: ${_vm.color || 'var(--primary)'}; font-size: ${_vm.width || '24px'}`),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }